module.exports = __webpack_public_path__ + "static/media/19.58892bd1.png";